import Vue from 'vue';

const success = (resolve, { data }) => {
  resolve(data);
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (client) => {
  const data = client;
  return new Promise((resolve, reject) => {
    Vue.$http
      .request({
        url: '/clients',
        data,
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  });
};



// WEBPACK FOOTER //
// ./src/app/services/client/store.js